import { render, staticRenderFns } from "./horizontal-ranking.vue?vue&type=template&id=277a735e&"
import script from "./horizontal-ranking.vue?vue&type=script&lang=js&"
export * from "./horizontal-ranking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports